<template>
  <div class="m-edition-map-chart">
    <div class="m-edition-map-chart-item-left">
      <MoleculeEditionMapChartBoard
        :progress="progress"
        :submenu-item="submenuItem"
        @changeRightSubMolecule="changeRightSubMolecule"
      />
    </div>
    <div class="m-edition-map-chart-item-right">
      <MoleculeEditionMapChartSubMenu
        :submenu-item="submenuItem"
        @changeRightSubMolecule="changeRightSubMolecule"
      />
      <MoleculeEditionMapChartMessages
        v-if="submenuItem === 2"
        :element="element"
      />
      <MoleculeEditionMapChartNode
        v-else-if="submenuItem === 0"
        :element="element"
      />
      <MoleculeEditionMapChartPoints
        v-else
        :element="element"
        @setProgress="setProgress"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChart',

  components: {
    MoleculeEditionMapChartBoard: () => import('@/components/molecules/MoleculeEditionMapChartBoard'),
    MoleculeEditionMapChartMessages: () => import('@/components/molecules/MoleculeEditionMapChartMessages'),
    MoleculeEditionMapChartNode: () => import('@/components/molecules/MoleculeEditionMapChartNode'),
    MoleculeEditionMapChartPoints: () => import('@/components/molecules/MoleculeEditionMapChartPoints'),
    MoleculeEditionMapChartSubMenu: () => import('@/components/molecules/MoleculeEditionMapChartSubMenu')
  },

  props: {
    element: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      progress: [],
      submenuItem: 0
    }
  },

  methods: {
    changeRightSubMolecule (item) {
      this.submenuItem = item
    },

    setProgress (progress) {
      this.progress = [...progress]
    }
  }
}
</script>
